var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.users,"item-text":"text","item-value":"id","label":_vm.labelText,"clearable":"","dense":"","outlined":""},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedUser),callback:function ($$v) {_vm.selectedUser=$$v},expression:"selectedUser"}})
}
var staticRenderFns = []

export { render, staticRenderFns }